var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokerSeats10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 3,
    width: 14,
    height: 10,
    rx: 5,
    fill: "#9E63CB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.066 4.366V11.5H4.89V5.763l-1.744.59v-.971l2.779-1.016h.141zM13.17 7.35v1.162c0 .556-.054 1.032-.165 1.425-.107.391-.264.709-.469.953-.205.244-.45.423-.737.537-.283.114-.6.17-.952.17-.28 0-.54-.035-.782-.107a1.908 1.908 0 01-1.137-.928 3.309 3.309 0 01-.313-.874 5.733 5.733 0 01-.107-1.176V7.35c0-.56.055-1.032.166-1.416.11-.388.268-.702.473-.943.206-.244.45-.421.733-.532.286-.11.605-.166.957-.166a2.7 2.7 0 01.781.107 1.83 1.83 0 011.133.913c.137.238.24.526.313.865.071.335.107.726.107 1.172zm-1.176 1.328V7.174c0-.283-.016-.532-.049-.747a2.211 2.211 0 00-.146-.552 1.099 1.099 0 00-.234-.371.825.825 0 00-.323-.21 1.138 1.138 0 00-.405-.068c-.182 0-.345.035-.488.107a.878.878 0 00-.362.332 1.813 1.813 0 00-.224.606 4.75 4.75 0 00-.074.903v1.504c0 .286.017.538.05.757.032.218.08.405.146.561.065.153.143.28.234.381.095.098.202.17.322.215.124.045.26.068.406.068.185 0 .35-.036.493-.107a.904.904 0 00.361-.342c.098-.16.171-.366.22-.62.049-.254.073-.558.073-.913z",
    fill: "#000"
  })));
}
SvgPokerSeats10.displayName = 'PokerSeats10';
export default SvgPokerSeats10;